import Index from '../../pages/snail/nyf/index'
import Pc from "../../pages/snail/nyf/pc";

const base = 'nyf'

const routes = [
    {
        path: `/${base}/index`,
        name: `${base}-index`,
        component: Index
    },
    {
        path: `/${base}/enter*`,
        name: `${base}-enter`,
        component: Index
    },
    {
      path: `/${base}/pc`,
      name: `${base}-pc`,
      component: Pc
    }
]

export default routes



// WEBPACK FOOTER //
// ./src/router/snail/nyf.js